const getFaqGrouping = (faqs) =>
  faqs?.reduce((faqs, current) => {
    (faqs[current['generalHeader']] =
      faqs[current['generalHeader']] || []).push(current);
    return faqs;
  }, Object());

export default getFaqGrouping;
